/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import type { PropsWithChildren } from 'react';

const styles = {
  container: css`
    margin-top: auto;
    flex-shrink: 0;
  `,
};

/**
 *
 * The SideNavBottomSlot component is used to render the bottom slot of the sidebar.
 * @param children - The children to render in the bottom slot
 * @returns The SideNavBottomSlot component
 */
export const SideNavBottomSlot = ({ children }: PropsWithChildren) => {
  return <div css={styles.container}>{children}</div>;
};

export default SideNavBottomSlot;
